import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the tableBalanceAdjustmentsView.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable',
                            id: 'datatable', // ID for the first datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'detailTittle',
                                    header: '',
                                    width: 70,
                                    height: 25,
                                    tooltip: _('Detalles'), // Tooltip for details column
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                                    },
                                },
                                {
                                    id: 'UserId',
                                    header: _('ID Usuario'), // Header for User ID column
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Header for Date column
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    sort: 'text',
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'UserName',
                                    header: _('Nombre Usuario'), // Header for User Name column
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'Currency',
                                    header: _('Moneda'), // Header for Currency column
                                    width: 80,
                                    sort: 'int',
                                },
                                {
                                    id: 'CreatedLocalDate',
                                    header: _('Fecha de creación'), // Header for Creation Date column
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    sort: 'text',
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'AmountDeposit',
                                    header: _('Saldo recargas'), // Header for Deposit Amount column
                                    width: 150,
                                    sort: 'int',
                                    format: webix.Number.numToStr({
                                        // Formatting for number display
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2,
                                    }),
                                },
                                {
                                    id: 'AmountWithdraw',
                                    header: _('Saldo retiros'), // Header for Withdraw Amount column
                                    width: 150,
                                    sort: 'int',
                                    format: webix.Number.numToStr({
                                        // Formatting for number display
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2,
                                    }),
                                },
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    // Event handler for details click
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('resume:id', [
                                        item.UserId, // Call event with User ID
                                    ]);
                                    $$('dColl').expand(); // Expand details section
                                    $$('formDetails').clear(); // Clear details form
                                    $$('a5').scrollTo(0, 1000); // Scroll to a specific position
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    // Event before loading data
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // Event after loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // Event when the datatable is ready
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Data fetch configuration
                            pager: 'pagerA', // Pager ID for pagination
                        },
                        {
                            type: 'wide',
                            view: 'datatable',
                            id: 'datatable2', // ID for the second datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'detailTittle',
                                    header: '',
                                    width: 70,
                                    height: 25,
                                    tooltip: _('Detalles'), // Tooltip for details column
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                                    },
                                },
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Header for Date column
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    sort: 'text',
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'Currency',
                                    header: _('Moneda'), // Header for Currency column
                                    width: 80,
                                    sort: 'int',
                                },
                                {
                                    id: 'AmountDeposit',
                                    header: _('Saldo recargas'), // Header for Deposit Amount column
                                    width: 150,
                                    sort: 'int',
                                    format: webix.Number.numToStr({
                                        // Formatting for number display
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2,
                                    }),
                                },
                                {
                                    id: 'AmountWithdraw',
                                    header: _('Saldo retiros'), // Header for Withdraw Amount column
                                    width: 150,
                                    sort: 'int',
                                    format: webix.Number.numToStr({
                                        // Formatting for number display
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2,
                                    }),
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Event before loading data
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // Event after loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            onClick: {
                                details: function (euv, id) {
                                    // Event handler for details click
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('resume:id', [
                                        item.UserId, // Call event with User ID
                                    ]);
                                },
                            },
                            ready: function () {
                                // Event when the datatable is ready
                                if (!datatable2.count()) {
                                    // Check if there are no items
                                    webix.extend(datatable2, webix.OverlayBox); // Extend with overlay functionality
                                    datatable2.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
                            pager: 'pagerB', // Pager ID for pagination
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The main datatable instance.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the main datatable
        var url =
            devConfig.geturlApi() + // API URL for fetching data
            'Report/GetBalanceUsers?Partner=' +
            id_partner +
            '&';
        var filter = ''; // Filter string for API requests
        var grid2 = $$('datatable2'); // Reference to the second datatable
        grid2.hide(); // Hide the second datatable initially
        $$('toolbar').hide(); // Hide the main toolbar

        // Event listener for filtering adjustments
        this.on(this.app, 'balanceAdjustments:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            var typeTable = 0; // Initialize table type

            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    // Check for Type filter
                    if (object[i][1] == 0) {
                    } else {
                        typeTable = 1; // Set table type based on filter
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Append partner ID to filter string

            if (typeTable == 0) {
                // Check table type for loading data
                grid.show(); // Show the first datatable
                grid2.hide(); // Hide the second datatable
                grid.clearAll(); // Clear existing data
                grid.load(
                    url + '?start=0&count=' + grid.data.$pagesize + string1, // Load data with filters
                );
                $$('toolbar').show(); // Show the main toolbar
                $$('toolbar2').hide(); // Hide the second toolbar
            } else {
                grid2.show(); // Show the second datatable
                grid.hide(); // Hide the first datatable
                grid2.clearAll(); // Clear existing data
                grid2.load(
                    url + '?start=0&count=' + grid.data.$pagesize + string1, // Load data with filters
                );
                $$('toolbar2').show(); // Show the second toolbar
                $$('toolbar').hide(); // Hide the main toolbar
            }
            filter = string1; // Update filter variable
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event for item click in the grid
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Call event with User ID
        });

        // Popup window for adding adjustments
        var popupAdd = webix.ui({
            view: 'window',
            id: 'AddAdjustments', // ID for the popup window
            width: 450,
            height: 450,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Ajustar Saldo'), // Label for the popup
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon for the popup
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: true, // Make the popup modal
            body: {
                view: 'form',
                id: 'addform', // ID for the form in the popup
                elements: [
                    {
                        view: 'text',
                        label: _('Usuario Id:'), // Label for User ID input
                        name: 'UserId',
                        labelWidth: 150,
                        type: 'number', // Input type
                        required: true, // Make this field required
                    },
                    {
                        view: 'combo',
                        label: _('Tipo Saldo:'), // Label for Balance Type input
                        name: 'TypeBalance',
                        required: true, // Make this field required
                        options: [
                            { id: '0', value: _('Saldo recargas') }, // Option for Deposit Balance
                            { id: '1', value: _('Saldo retiros') }, // Option for Withdraw Balance
                        ],
                        labelWidth: 150,
                    },
                    {
                        view: 'text',
                        label: _('Monto:'), // Label for Amount input
                        name: 'Amount',
                        type: 'number', // Input type
                        labelWidth: 150,
                        required: true, // Make this field required
                    },
                    {
                        view: 'textarea',
                        label: _('Descripción:'), // Label for Description input
                        name: 'Description',
                        labelWidth: 150,
                        required: true, // Make this field required
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup on cancel
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for AJAX request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'BalanceAdjustments/Adjustment', // API endpoint for saving adjustments
                                                '{"UserId":"' +
                                                    values.UserId +
                                                    '", "TypeBalance":"' +
                                                    values.TypeBalance +
                                                    '", "Amount":"' +
                                                    values.Amount +
                                                    '", "Description":"' +
                                                    values.Description +
                                                    '", "Partner":"' +
                                                    id_partner +
                                                    '"}', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Show error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response JSON
                                                        if (json.HasError) {
                                                            // Check for errors in response
                                                            webix.message({
                                                                title: '¡Error!',
                                                                type: 'alert-error',
                                                                text: json.AlertMessage, // Show error message
                                                            });
                                                        } else {
                                                            webix.message(
                                                                'Saldo Ajustado', // Show success message
                                                            );
                                                            grid.clearAll(); // Clear the grid
                                                            grid.load(
                                                                url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload data with filters
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Hide the popup after saving
                                    } else {
                                        webix.message({
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Show validation error message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate form on change
                        },
                    },
                },
            },
        });
        this.on(this.app, 'addAdjustment:button', (filter) => {
            popupAdd.show(); // Show the popup when the event is triggered
        });
    }
}

// FILE DOCUMENTED
